/**
 * - Checks for undefined or null
 * - Checks for string's lentgth
 * - Checks for array with no members
 * - Checks for object with no enumerable properties
 * @param  {any} value
 * @return {Boolean}
**/

const isEmpty = value => {
    if (typeof value === 'number' || typeof value === 'boolean') return false;
    if (typeof value === 'undefined' || value === null) return true;
    if (typeof value.length !== 'undefined') return value.length === 0;

    let objectProperties = 0;
    for (const property in value) {
        if (value.hasOwnProperty(property)) objectProperties ++;
    }

    return objectProperties === 0;
};

export default isEmpty;
